import script from "./ReturnPdf.vue?vue&type=script&lang=js"
export * from "./ReturnPdf.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__